import React, { useState, useEffect } from 'react';

const ModalCompareItem = ({ fuse, fetchFuse, handleCloseModal }) => {
  const [scoreClass, setScoreClass] = useState('fuse-number');
  const [scoreDisplay, setScoreDisplay] = useState('0%');
  const [frequencyFormatted, setFrequencyFormatted] = useState('N/A');

  // Calculate ignition thrust
  useEffect(() => {
    const totalBars = 24;

    // Safely access 'Scale Ceiling' using optional chaining and default value
    const scaleCeilingValue = fuse.ignition_context?.['Scale Ceiling'];
    const scaleCeiling = parseFloat(scaleCeilingValue) || 100; // Default to 100 if undefined or invalid

    // Ensure 'ignition_thrust' is a valid number
    const ignitionThrust = parseFloat(fuse.ignition_thrust) || 0;
    const scoreNumber = ignitionThrust * 100;
    const scorePercentage = (scoreNumber * 100) / scaleCeiling;
    const percentageIndex = Math.ceil((scorePercentage * totalBars) / 100);

    const frequency_formatted = fuse.frequency
      ? parseFloat(fuse.frequency).toFixed(1)
      : 'N/A';
    setFrequencyFormatted(frequency_formatted);

    // Determine score display
    if (scoreNumber > 3000) {
      setScoreDisplay('30X+');
    } else if (scoreNumber > 500) {
      setScoreDisplay(`${(scoreNumber / 100).toFixed(1)}X`);
    } else {
      setScoreDisplay(`${Math.round(scoreNumber)}%`);
    }

    // Determine score class based on percentage index
    if (percentageIndex < 6) {
      setScoreClass('fuse-number low');
    } else if (percentageIndex < 13) {
      setScoreClass('fuse-number mid-low');
    } else if (percentageIndex < 20) {
      setScoreClass('fuse-number mid-high');
    } else {
      setScoreClass('fuse-number high');
    }
  }, [fuse.ignition_thrust, fuse.ignition_context, fuse.frequency]);

  const handleFetchFuse = (fuseID) => {
    fetchFuse(fuseID);
    handleCloseModal();
  };

  return (
    <div
      className={`fuselight-dashboard-list-item ${
        fuse.isDeleting ? 'fade-out' : ''
      }`}
    >
      <div className="project-info" onClick={() => handleFetchFuse(fuse.ID)}>
        <div className="project-info-left">
          <p>
            {fuse.brand_name || 'N/A'} + {fuse.celebrity_name || 'N/A'}
          </p>
          <p>
            {Math.round(Number(fuse.avg_monthly_mentions)).toLocaleString(
              'en-US'
            )}
          </p>
        </div>
        <div className="project-info-right">
          <p>
            {Math.round(Number(fuse.predicted_media_mentions)).toLocaleString(
              'en-US'
            )}
          </p>
          <p>{frequencyFormatted}</p>
          <p>
            {Math.round(Number(fuse.predicted_impressions)).toLocaleString(
              'en-US'
            )}
          </p>
          <p>{frequencyFormatted}</p>
          <p>
            <span className={scoreClass}>{scoreDisplay}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ModalCompareItem;
